"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Lightning16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6876 0C13.695 0 13.6999 0.00774789 13.6966 0.0143912L11.2598 5H12.9775C14.7209 5 15.6372 7.06737 14.4673 8.35923L8.17133 15.3114C6.7508 16.88 4.18313 15.471 4.74313 13.4303L5.41004 11H3.01651C1.50669 11 0.535698 9.39744 1.23508 8.05908L5.4465 0H13.6876ZM8.03281 9L6.67183 13.9596C6.66904 13.9697 6.68181 13.9767 6.68888 13.9689L12.9849 7.01671C12.9907 7.01028 12.9861 7 12.9775 7H8.05618L10.5 2H6.65798L3.00765 8.98537C3.00417 8.99203 3.009 9 3.01651 9H8.03281Z", fill: "black" }));
}
function Lightning16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Lightning16Svg, Object.assign({}, svgProps)));
}
exports.default = Lightning16;
//# sourceMappingURL=Lightning16.js.map